import bem from '../modules/bem';
import utils from '../modules/utils';
import viewport from '../modules/viewport';

class LinksOverflow {

	static get block() {
		return bem.block('links-overflow');
	}

	static get counter() {
		LinksOverflow._counter = (LinksOverflow._counter || 0) + 1;
		return LinksOverflow._counter;
    }

    get id() {
		return this._id;
    }

	constructor($lo){

		this._id = LinksOverflow.counter;

		this.$lo = {
			root: $lo,
			list: $lo.querySelector(LinksOverflow.block.selector('list')),
			items: $lo.querySelectorAll('li')
		};
		this.$overflow = {
			root: null,
			list: null,
			toggle: null,
			menu: null
		};
		this.$body = document.querySelector('body');

		this.data = this.$lo.root.dataset;
		this.ref = this.data.id || this.id;
		this.overflowOpen = false;

		this.settings = {
			toggleWidth: null,
			svgPath: this.data.svgPath || '/assets/img/sprite.svg'
		};

		this.init = this.init.bind(this);
		this.createOverflow = this.createOverflow.bind(this);
		this.onResize = this.onResize.bind(this);
		this.updateSettings = this.updateSettings.bind(this);
		// this.mouseHandler = this.mouseHandler.bind(this);
		this.touchHandler = this.touchHandler.bind(this);
		this.cleanUp = this.cleanUp.bind(this);

		this.init();

	}

	init(){

		this.createOverflow();

		viewport.addListener('linksOverflow-' + this.ref, this.onResize);
		this.onResize();

	}

	createOverflow(){

		this.$overflow.root = document.createElement('li');
		this.$overflow.toggle = document.createElement('a');
		this.$overflow.menu = document.createElement('ul');

		this.$overflow.root.classList.add('links-overflow__more');
		this.$overflow.toggle.innerHTML = '<span class="icon-text"><span class="icon-text__t">More</span> <svg class="icon-text__i icon"><use xlink:href="' + this.settings.svgPath + '#triangle-down"></use></svg></span>';
		this.$overflow.menu.classList.add('links-overflow__menu');

		this.$overflow.root.appendChild(this.$overflow.toggle);
		this.$overflow.root.appendChild(this.$overflow.menu);

		this.$lo.list.appendChild(this.$overflow.root);

		if( Modernizr.touchevents ){

			$(this.$overflow.toggle).on('touchend', this.touchHandler);

			$(this.$overflow.root)
				.on('touchend', function(e){

					e.stopPropagation();

				});

		}
		// else{

		// 	$(this.$overflow.toggle).on('mouseenter mouseleave mouseup', this.mouseHandler);

		// }

	}

	updateSettings(){

		this.$overflow.root.classList.remove(bem.states.hidden);

		this.settings.toggleWidth = this.$overflow.root.offsetWidth;

		this.$overflow.root.classList.add(bem.states.hidden);

	}

	onResize(){

		this.updateSettings();

		this.$lo.root.style.overflow = 'hidden';

		let availableSpace = this.$lo.root.offsetWidth;
		let itemsWidth = 0;

		// empty overflow menu
		this.$overflow.menu.innerHTML = '';

		// show all items
		for (var i = 0; i < this.$lo.items.length; i++) {
			const $item = this.$lo.items[i];

			$item.classList.remove(bem.states.hidden);

			itemsWidth += parseFloat($item.offsetWidth);
		}

		// show overflow if anything doesn't fit
		if( itemsWidth > availableSpace ){
			availableSpace -= this.settings.toggleWidth;

			this.$overflow.root.classList.remove(bem.states.hidden);
		}

		// hide any items that are over the available space
		const navOffset = utils.getCoords(this.$lo.root).left;

		for (var j = 0; j < this.$lo.items.length; j++) {
			const $item = this.$lo.items[j];
			const rightEdge = (utils.getCoords($item).left + $item.offsetWidth) - navOffset;

			if( rightEdge > availableSpace ){
				$item.classList.add(bem.states.hidden);
				const $clone = $item.cloneNode(true);

				$clone.classList.remove(bem.states.hidden);

				this.$overflow.menu.appendChild($clone);
			}
		}

		this.$lo.root.style.removeProperty('overflow');

	}

	toggleOpen(force){

		this.$overflow.root.classList.toggle(bem.states.active, force);

		this.overflowOpen = force;

	}

	// mouseHandler(e){

	// 	e.preventDefault();

	// }

	touchHandler(e){

		e.preventDefault();

		const $body = $(this.$body);
		const cleanUp = this.cleanUp;

		if( !this.overflowOpen ){

			this.toggleOpen(true);

			setTimeout(function(){

				$body
					.on('touchend.tl', cleanUp);

			}, 50);

		}

	}

	cleanUp(){

		$(this.$body).off('touchend.tl');
		this.toggleOpen(false);

	}

}

module.exports = LinksOverflow;

// module.exports = () => {
// 	[].slice
// 		.call(document.querySelectorAll(LinksOverflow.block.selector()))
// 		.forEach($el => new LinksOverflow($el));
// };



// WEBPACK FOOTER //
// ./src/js/modules/links-overflow.js